import { render, staticRenderFns } from "./popup-folder.vue?vue&type=template&id=6bbab510&"
import script from "./popup-folder.vue?vue&type=script&lang=js&"
export * from "./popup-folder.vue?vue&type=script&lang=js&"
import style0 from "./popup-folder.vue?vue&type=style&index=0&id=6bbab510&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports